import { HttpClient } from "@angular/common/http";
import { ErrorHandler, inject, Injectable, signal } from "@angular/core";
import { lastValueFrom } from "rxjs";

@Injectable({ providedIn: "root" })
export class AppLoadService {
	private readonly errorHandler = inject(ErrorHandler);
	private readonly httpClient = inject(HttpClient);

	private _bootstrapProperties = signal<stages.authenticationservice.main.BootstrapProperties>({
		basicAuthenticationEnabled: true,
		defaultLanguage: "en",
		browserLanguage: "en",
		licenseTimeoutSoon: false,
		systemLicenseTimeout: false,
		licenseValidityDate: null,
		licensePoolName: null,
		maintenance: {
			maintenanceMode: "NONE",
			unavailableFrom: null,
			unavailableTo: null,
			contact: null,
			maintenanceId: null,
		},
		supportedLanguages: ["en"],
		bannerEnabled: false,
		idps: [],
		passiveAuthSupported: false,
	});

	readonly bootstrapProperties = this._bootstrapProperties.asReadonly();

	constructor() {
		this.refreshBootstrapProperties();
	}

	async refreshBootstrapProperties(): Promise<void> {
		try {
			const newProperties = await lastValueFrom(
				this.httpClient.get<stages.authenticationservice.main.BootstrapProperties>("auth/public/bootstrapProperties"),
			);
			this._bootstrapProperties.set(newProperties);
		} catch (e: unknown) {
			this.errorHandler.handleError(e);
			console.log("Could not load bootstrap properties");
		}
	}
}
